import { render, staticRenderFns } from "./saveUserConfirm.vue?vue&type=template&id=a6c34dd2&"
import script from "./saveUserConfirm.vue?vue&type=script&lang=js&"
export * from "./saveUserConfirm.vue?vue&type=script&lang=js&"
import style0 from "./saveUserConfirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports